import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Footer.module.scss';

const HireExperts = ({ omitHeading = false }) => {
  return (
    <ul className={styles.linkList}>
      {!omitHeading && (
        <li>
          <a href="/hire-a-freelancer">Hire experts</a>
        </li>
      )}
      <li>
        <a href="/howitworks">How it works</a>
      </li>
      <li>
        <a href="/post-a-job">Post a job</a>
      </li>
      <li>
        <a href="/hire-a-freelancer/video-and-animation">
          Hire video &amp; animation experts
        </a>
      </li>
      <li>
        <a href="/hire-a-freelancer/programming">Hire developers</a>
      </li>
      <li>
        <a href="/hire-a-freelancer/graphic-design">Hire designers</a>
      </li>
      <li>
        <a href="/hire-a-freelancer/music">Hire music &amp; audio experts</a>
      </li>
      <li>
        <a href="/hire-a-freelancer/digital-marketing">
          Hire marketing experts
        </a>
      </li>
      <li>
        <a href="/hire-a-freelancer">Hire experts worldwide</a>
      </li>
    </ul>
  );
};

HireExperts.propTypes = {
  omitHeading: PropTypes.bool,
};

export default HireExperts;
